import { FC } from "react";
import { Field, Input } from "@ngt/forms-core";
import { Box } from "@mui/material";
import { GoogleAutocompleteFormField } from "../../../../api/dtos/dtos";
import TextFieldControlLabel from "../labels/TextFieldControlLabel";
import InputGoogleAutocomplete from "../InputGoogleAutocomplete";
import FieldErrors from "../utils/FieldErrors";
import { IFormFieldComponentProps } from "../types/FieldTypes";

interface IInputFieldGoogleAutocompleteProps {
    field: GoogleAutocompleteFormField;
}

const InputFieldGoogleAutocomplete: FC<IInputFieldGoogleAutocompleteProps> = ({
    field
}) => {
    return (
        <TextFieldControlLabel
            field={field}
            control={
                <Box sx={{ width: "100%" }}>
                    <Input
                        component={InputGoogleAutocomplete}
                        placeholder={field.placeholder ?? undefined}
                    />
                </Box>
            }
        />
    );
};

const FormFieldGoogleAutocomplete: FC<IFormFieldComponentProps<GoogleAutocompleteFormField>> = ({ field, form }) => {
    return (
        <Field propertyPath={`${form.name}.${field.name}`}>
            <InputFieldGoogleAutocomplete field={field} />
            <FieldErrors />
        </Field>
    );
};

export default FormFieldGoogleAutocomplete;